import React, { useEffect, useRef, useState } from 'react'
import { Navbar } from '../../../components/navbar/Navbar'
import BackButton from '../../../components/button/BackButton'
import Label from '../../../components/title/label'
import Input from '../../../components/input/Input'
import Table from '../../../components/table/Table'
import { Button } from '../../../components/button/button'
import axios from 'axios'
import SearchInput from '../../../components/input/SearchInput'
import { useNavigate } from 'react-router-dom'
import { BACKEND_URL } from '../../../constants/constant'

function SituationNatureImpot() {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Function to format date in "dd/mm/yyyy hh:mm:ss" format
  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day}/${month}/${year} à ${hours}:${minutes}:${seconds}`;
  };






const navigate = useNavigate()
const [searchYear, setSearchYear] = useState('');
const [recepisse, setRecepisse] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [startDate, setStartDate] = useState('');
const [endDate, setEndDate] = useState('');

useEffect(() => {
  // Récupérer les données depuis le backend
  axios.get(`${BACKEND_URL}/recette/getEnregistrementdeclaration`)
    .then((response) => setRecepisse(response.data))
    .catch((error) => console.error(error));
}, []);

// Filtrer les données par référence fiscale et date
const filteredData = recepisse.filter((item) =>
  item.reference_fiscal && item.reference_fiscal.toLowerCase().includes(searchTerm.toLowerCase())
);

const filteredRecepisse = filteredData.filter(item => {
  const itemDate = new Date(item.date_creation);
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  // Vérifier l'année et appliquer le filtre
  const matchesYear = searchYear ? item.annee && item.annee.toString() === searchYear : true;

  return (!startDate || itemDate >= start) && (!endDate || itemDate <= end) && matchesYear;
});


// Calculer le total par type de paiement
// const calculateTotal = (type) => {
//   return filteredRecepisse
//     .filter(item => item.type_payment.trim().toLowerCase() === type.toLowerCase())
//     .reduce((total, item) => total + parseFloat(item.montant_verser || 0), 0);
// };

// Calcul du total des montants annulés
// const totalMontantAnnuler = recepisse
//   .filter(item => item.annulation === true)
//   .reduce((total, item) => total + parseFloat(item.montant_verser || 0), 0);

// // Calcul des différents totaux par type de paiement
// const totalMontantVerserVirement = calculateTotal("virement");
// const totalMontantVerserEspece = calculateTotal("espece");
// const totalMontantVerserCheque = calculateTotal("cheque");
// const totalMontantVerserAutre = calculateTotal("autre");
// const totalMontantVerserBar = calculateTotal("bar");
// const totalMontantVerserTresor = calculateTotal("trésor");
// const totalMontantVerserDepot = calculateTotal("dépot");

// // Calcul du total à payer
// const totalMontantAPayer = totalMontantVerserVirement +
//   totalMontantVerserEspece +
//   totalMontantVerserCheque +
//   totalMontantVerserAutre +
//   totalMontantVerserBar +
//   totalMontantVerserTresor +
//   totalMontantVerserDepot - totalMontantAnnuler;

// Définir les en-têtes de la table
const headers = ['N° Récepissé', 'Référence Fiscal', 'année', "Période", 'P1', 'P2', "Impôt", "Nature Impôt", "montant à payer", "montant à verser", "reste à payer", "Code Banque", "Mode de payment"];

// Formater les données pour l'affichage et l'export
const formattedData = filteredRecepisse.map(item => ({
  'N° Récepissé': item.numero_recepisse,
  'Référence Fiscal': item.reference_fiscal,
  'année': item.annee,
  'Période': item.periode,
  'P1': item.periode1,
  'P2': item.periode2,
  'Impôt': item.numero_impot,
  'Nature Impôt': item.base_impot,
  'montant à payer': item.montant_a_payer,
  'montant à verser': item.montant_verser,
  'reste à payer': item.reste_a_payer,
  'Code Banque': item.code_banque,
  'Mode de payment': item.type_payment
}));

// Fonction pour exporter les données en Excel
// const exportToExcel = () => {
//   // Convertir le tableau d'objets en une feuille de calcul Excel
//   const worksheet = XLSX.utils.json_to_sheet(formattedData);
//   // Créer un nouveau classeur Excel
//   const workbook = XLSX.utils.book_new();
//   // Ajouter la feuille de calcul au classeur
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Recepisse Data");
//   // Générer et télécharger le fichier Excel
//   XLSX.writeFile(workbook, 'recettes_a_recouvrer.xlsx');
// };
 const NavbarContent = (
     <div className='flex justify-between'>
     <div className='text-white'>
     Situation Nature Impot    
       </div>
         <div>
           <BackButton to="/gestion"></BackButton>
         </div>
     </div>
       )



       const printRef = useRef(null);

       const downloadPDF = () => {
           if (printRef.current) {
               const content = printRef.current.innerHTML;
               const originalContent = document.body.innerHTML;
   
               const printStyle = document.createElement('style');
               printStyle.innerHTML =
                   '@media print { body { visibility: hidden; } .print-content { visibility: visible; } }';
               document.head.appendChild(printStyle);
   
               document.body.innerHTML = `<div class="print-content">${content}</div>`;
   
               window.print();
   
               document.head.removeChild(printStyle);
               document.body.innerHTML = originalContent;
               window.location.reload();
           }
       };
   
       
       return (
        <div  className='bg-[#212122] h-screen w-full'>
        <Navbar content={NavbarContent}></Navbar>
 <div className='m-4'>
       <div className='bg-black p-4 flex justify-between rounded'>
 
  <div className='flex flex-row'>
  <div className='flex flex-col'>
  <Label text="Du "></Label>
  <Input type="date" className="mt-2"
  
  onChange={(e)=> setStartDate(e.target.value)}
  ></Input>
  </div>
 <div className='flex flex-col ml-4'>
 <Label text="Au "></Label>
 <Input type="date"  className="mt-2"
 onChange={(e)=> setEndDate(e.target.value)}
 ></Input>
 </div>
 <div className='flex flex-col ml-4'>
<Label text="Référence Fiscal "></Label>
<SearchInput onChange={(e)=> setSearchTerm(e.target.value)} className={"mt-2"}></SearchInput>
</div>
<div className='flex flex-col ml-4'>
  <Label text="Ce programme à été lancé le "></Label>
  <p className='text-white text-lg mt-2'>{formatDate(currentDateTime)}</p>
 
 </div>
 {/* <div className='flex flex-col ml-4 '>
  <Label text="Total Verser "></Label>
  <p className='text-white text-xl mt-2'>{totalMontantAPayer}</p>
 </div> */}
 <div className='flex flex-col ml-4'>
  <Label text="Année"></Label>
  <Input type="number" className="mt-2"
    onChange={(e) => setSearchYear(e.target.value)}
  />
</div>

  </div>


 </div>
  <div className='bg-black p-4 mt-2 flex justify-between rounded'>
  
 
 
 </div>
 
 <div ref={printRef} className='mt-2  flex justify-center '>
 <Table headers={headers} data={formattedData.map(item => Object.values(item))}></Table>
 </div>
 
      <div className='flex justify-between mt-2'>
        <Button type="submit" children="Voir par Nature Impot  " onClick={ () => navigate("/ListreNatureImpotSituation")} ></Button>
        <Button type="submit" children="Impression " onClick={ () => downloadPDF()} ></Button>
        <Button type="submit" children="Quitter" onClick={() => {window.location.href="/ConsultationGestion"}}></Button>
      </div>
         </div>
         </div>
       )
}


export default SituationNatureImpot